import React, { useState, useRef, useEffect } from 'react';
import './B2Top.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';


const B2Top = () => {
    // === Back to top ===
    
    const [position, setPosition] = useState({top: 0, left: 0})
    // const [visibility, setVisibility] = useState(false)
    useEffect(() => {
        window.scroll({
        top: position.top,
        left: position.left,
        behavior: 'smooth'
        })
    })
    
    
    const scrollTop = useRef()
    useEffect(( ) => {
        window.addEventListener('scroll', (e) => {
        window.scrollY > 200 
        ? scrollTop.current.style.display = 'inline-block'
        : scrollTop.current.style.display = 'none'
        })
    })
    
    return (
        <button onClick={() => setPosition({...position, position: {top: 0, left: 0}})} ref={scrollTop} className="back-to-top">
            <FontAwesomeIcon icon={faAngleUp} />
        </button>
    )
}

export default B2Top
